export default "/assets/043037952103c43f.svg"